<template>
  <OppleModal
    class="opple-child-reset-modal"
    :title="$t('deviceMsg.resetRelayDevice')"
    :visible="visible"
    :extend-style="{width: '950px'}"
    :is-show-warn="false"
    :is-show-btn="false"
    @onClose="modalClose"
  >
    <div class="opple-child-reset-modal_container">
      <ul>
        <li v-for="(item, index) in childList" :key="index" class="opple-child-reset_single">
          <span>{{ item.Name }}</span>
          <OppleButton type="danger" @click="reset(item)">
            {{ $t('courseDataySync.reset') }}
          </OppleButton>
        </li>
      </ul>
      <p class="opple-child-reset_describe">
        <i class="icon-11" />{{ ((childList[0] || {}).tip?.Txt || '').replace(/[^。]+？$/, "") }}
      </p>
    </div>
  </OppleModal>
</template>
<script>
import OppleButton from '@/components/Base/OppleButton/index.vue';
import OppleModal from '@/components/OppleModal/index.vue'
import {
  ResetDevicesInChannel
} from '@/axios/IDevice.js';
import { alertsuccess } from '@/assets/js/common.js'

export default {
  name: 'OppleQaModal',
  components: {
    OppleModal,
    OppleButton
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    VDeviceId: {
      type: String,
      default: ''
    },
    childList: {
      type: Array,
      default: () => ([])
    },
    model: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
   
    }
  },
  watch: {
    visible(val) {
     
    },
  },
  async created () {
  
  },
  mounted () {
  },
  methods: {
    async reset(item) {
      this.$confirm(`<div>
          <img style="width: 280px;" src=${item.tip?.Image}>
          <p>${item.tip?.Txt}</p>
        </div>`, {
          title: this.$t('addVirtualGateway.notice'),
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('deviceMsg.save'),
          cancelButtonText: this.$t('deviceMsg.cancle'),
          // type: 'warning'
      }).then(async () => {
        const res = await ResetDevicesInChannel({
          vDeviceId: this.model.VDeviceId,
          channelId: item.Value
        });

        if (Number(res.StatusCode) === this.$store.state.rightStatusCode) {
          alertsuccess(this, res.StatusCode)
        }
      
      }).catch(() => {
        // 用户取消删除操作
      })
             
    },

    async modalClose() {
      this.$emit('close')
    },

    modalOk() {
      this.$emit('ok')
    }
  }
}
</script>

<style lang="scss">
.opple-child-reset-modal {
  display: flex;

  &_container {
    width: 490px;
    margin: 30px auto;
  }

  .opple-child-reset_single {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px;
    margin-bottom: 10px;
    border-radius: 8px;
    border: 1px solid #B6B6B6;
  }

  .opple-child-reset_describe {
    display: flex;
    margin-top: 40px;
    align-items: center;
  }
}

</style>
